import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";

/**
 * Confirmation page shown after submitting the Early Bird interest form.
 * URL: /early-bird/tack
 * Does NOT trigger the webinar_signup_confirmed GTM event.
 */
export default function EarlyBirdThanks() {
  useEffect(() => {
    document.title = "Tack för din intresseanmälan · Aminah Ådin";
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF9F6] text-[#2C2825] flex items-center justify-center px-6 py-16"
      data-testid="earlybird-thanks-page"
    >
      <div className="max-w-xl w-full text-center">
        <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-[#F3EFEA] border border-[#DCD5CE] mb-8">
          <CheckCircle2 className="h-9 w-9 text-[#8A9A86]" strokeWidth={1.5} />
        </div>

        <h1
          data-testid="earlybird-thanks-headline"
          className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#2C2825] leading-[1.1]"
        >
          Tack för din intresseanmälan!
        </h1>

        <p
          data-testid="earlybird-thanks-message"
          className="mt-6 text-lg text-[#5C5651] leading-relaxed"
        >
          Vad roligt att du vill ta nästa steg! Aminah har tagit emot dina
          uppgifter och återkommer till dig inom kort via mejl för att boka in er tid.
        </p>

        <div className="mt-12">
          <Link
            to="/"
            data-testid="earlybird-thanks-back"
            className="inline-flex items-center gap-2 text-sm tracking-[0.2em] uppercase text-[#8C7362] hover:text-[#2C2825] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Tillbaka till startsidan
          </Link>
        </div>

        <div className="mt-16 pt-6 border-t border-[#E6DFD7] text-xs text-[#8C7362]">
          <Link
            to="/integritetspolicy"
            className="hover:text-[#2C2825] underline underline-offset-4"
            data-testid="earlybird-thanks-privacy-link"
          >
            Integritetspolicy
          </Link>
        </div>
      </div>
    </div>
  );
}
